var render, staticRenderFns
import script from "./VNumber.vue?vue&type=script&lang=js&"
export * from "./VNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3017f346",
  null
  
)

export default component.exports